<script lang="tsx">
  import { Skeleton } from "primevue";

  export default {
    components: { Skeleton },
    props: {
      hasCoordinates: { type: Boolean, default: false },
      hasGallery: { type: Boolean, default: false },
      hasLogo: { type: Boolean, default: false },
    },
  };
</script>

<template>
  <div v-if="hasLogo" class="logo" style="width: 150px; height: 150px;">
    <Skeleton style="width: 100%; height: 100%;"/>
  </div>

  <div class="contact">
    <!-- eslint-disable-next-line vue/no-unused-vars -->
    <div style="display: contents" v-for="_ in new Array(Math.round(Math.random() * 4 + 5))">
      <label><Skeleton class="skeleton" :style="{
        'min-width': `${Math.round(Math.random() * 5 + 3)}ch`,
      }"/></label>
      <span><Skeleton class="skeleton" :style="{
        'min-width': `${Math.round(Math.random() * 15 + 10)}ch`,
      }"/></span>
    </div>
  </div>

  <div v-if="hasGallery" class="gallery">
    <Skeleton style="width: 100%; min-height: 20em"/>
  </div>

  <div v-if="hasCoordinates">
    <Skeleton style="width: 100%;" class="map"/>
  </div>
</template>

<style lang="less" scoped>
  @import (reference) "@/style/main.less";

  .logo {
    float: right;
    max-width: 150px;
    height: auto;
    margin-block: var(--spacing-block);

    border: 1px solid var(--p-content-border-color);
    border-radius: var(--p-content-border-radius);

    @media screen and (width < @screen-width-small) {
      display: none;
    }
  }

  .contact {
    display: grid;
    // grid: auto-flow / max-content 1fr max-content 1fr;
    grid: auto-flow / max-content 1fr;
    flex-direction: column;
    gap: var(--spacing-inline) var(--spacing-block);
    margin-block: var(--spacing-block);

    & .skeleton {
      padding: 0.75em 1em;
      margin: 0.25em 0.25em;
    }


    & label:nth-child(2n+1) {
      justify-self: end;
      text-align: end;
    }

    & :nth-child(2n) {
      justify-self: start;
      align-self: start;
    }
  }

  .map {
    min-height: 40em;
  }

  .map, .gallery { margin-block: var(--spacing-block); }

  .image {
    display: inline-block;
    max-width: 100%;
    height: auto;
  }

  .thumb {
    display: inline-block;
    width: auto;
    max-height: 4em;
  }
</style>
